import { render, staticRenderFns } from "./PaymentDescription.vue?vue&type=template&id=169350a8&scoped=true"
import script from "./PaymentDescription.vue?vue&type=script&lang=ts"
export * from "./PaymentDescription.vue?vue&type=script&lang=ts"
import style0 from "./PaymentDescription.vue?vue&type=style&index=0&id=169350a8&prod&lang=scss"
import style1 from "./PaymentDescription.vue?vue&type=style&index=1&id=169350a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169350a8",
  null
  
)

export default component.exports